import { render, staticRenderFns } from "./add-general-time.vue?vue&type=template&id=6517a92d&scoped=true"
import script from "./add-general-time.vue?vue&type=script&lang=js"
export * from "./add-general-time.vue?vue&type=script&lang=js"
import style0 from "./add-general-time.vue?vue&type=style&index=0&id=6517a92d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6517a92d",
  null
  
)

export default component.exports